const DEBUG_SHIPPING = false;

if (!DEBUG_SHIPPING) {
  console.log = function() {};
}

      document.addEventListener('click', async function(e) {

        if (!e.target || e.target.id !== 'calculate-shipping') return;

        const zipInput = document.getElementById('shipping-zip');
        const ratesContainer = document.getElementById('shipping-rates');

        if (!zipInput || !ratesContainer) return;

        const zip = zipInput.value.replace(/\D/g, '');

        if (zip.length !== 8) {
          ratesContainer.innerHTML = '<p class="error">Digite um CEP válido</p>';
          return;
        }

        ratesContainer.innerHTML = '<p>Calculando...</p>';

        try {

          await fetch('/cart/prepare_shipping_rates.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              shipping_address: {
                zip: zip,
                country: 'BR',
                province: 'SP',
                city: 'Sumare'
              }
            })
          });

          setTimeout(async function() {

            const response = await fetch(
              '/cart/shipping_rates.json?shipping_address[zip]=' + zip +
              '&shipping_address[country]=BR' +
              '&shipping_address[province]=SP' +
              '&shipping_address[city]=Sumare'
            );

            console.info("Status:", response.status);

            const data = await response.json();
            console.log("Shipping data:", data);

            if (!data.shipping_rates || data.shipping_rates.length === 0) {
              ratesContainer.innerHTML = '<p>Nenhuma opção disponível.</p>';
              return;
            }

            let html = '';

            data.shipping_rates.forEach(function(rate) {

              let rawPrice = Number(rate.price);

              if (rawPrice > 999) {
                rawPrice = rawPrice / 100;
              }

              const price = rawPrice.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
              });

              html += 
                '<div class="shipping-option">' +
                  '<span>' + rate.name + '</span>' +
                  '<span>' + price + '</span>' +
                '</div>';

            });

            ratesContainer.innerHTML = html;

          }, 800);

        } catch (error) {

          console.error("Erro:", error);
          ratesContainer.innerHTML = '<p class="error">Erro ao calcular frete.</p>';

        }

      });

      // máscara CEP
      document.addEventListener('input', function(e) {
        if (e.target && e.target.id === 'shipping-zip') {
          let value = e.target.value.replace(/\D/g, '');
          if (value.length > 5) {
            value = value.slice(0, 5) + '-' + value.slice(5, 8);
          }
          e.target.value = value;
        }
      });